exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-radius {\n\tborder-radius: 8px !important;\n}\n", ""]);

// exports
